import { EvaluationSubmissionResult } from 'generated/graphql';
import styled from 'styled-components';

const IrrelevantAnswer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;
	color: ${(props) => props.theme.colors.slateBlue};
`;

export default function IrrelevantAnswerDisplay({
	result,
}: {
	result: EvaluationSubmissionResult;
}) {
	return (
		<IrrelevantAnswer>
			<p>
				<strong>{result.user.firstName}</strong> hoeft niets in te vullen.
			</p>
		</IrrelevantAnswer>
	);
}
